angular.module('AdminServices', ['MoreAppsConstants', 'ngResource']).run();